import { ChevronRight } from '@mui/icons-material'
import { Box, ButtonBase, Typography } from '@mui/material'
import { getRGBA } from 'utils/color'
import { useStyles } from './styles'

interface IOrganizationOptions {
  organizationName: string
  federalTaxId: string
  organizationType: string
  eSocialStatus: boolean
  showESocialChip: boolean
  handleChoseOrg: () => void
}

const getOrganizationTypeColor = (orgType: string): string => {
  const normalizedType = orgType.toLowerCase()

  if (normalizedType.includes('buyer') || normalizedType === 'rh') {
    return '#1976d2' // Blue for RH/Buyer
  } else if (normalizedType.includes('seller') || normalizedType === 'corretora') {
    return '#9c27b0' // Purple for Corretora/Seller
  } else if (normalizedType.includes('conducco')) {
    return '#2e7d32' // Green for Conducco
  } else if (normalizedType.includes('supplier')) {
    return '#f57c00' // Orange for Supplier
  }

  return '#1976d2' // Default blue
}

const getOrganizationTypeLabel = (orgType: string): string => {
  const normalizedType = orgType.toLowerCase()

  if (normalizedType.includes('buyer')) {
    return 'RH'
  } else if (normalizedType.includes('seller')) {
    return 'Corretora'
  }

  return orgType // Return original for other types
}

const OrganizationOptions = ({
  organizationName,
  federalTaxId,
  organizationType,
  eSocialStatus,
  showESocialChip,
  handleChoseOrg,
}: IOrganizationOptions) => {
  const classes = useStyles()
  const orgTypeColor = getOrganizationTypeColor(organizationType)
  const orgTypeLabel = getOrganizationTypeLabel(organizationType)

  return (
    <ButtonBase
      onClick={handleChoseOrg}
      className={classes.buttonBase}
    >
      <Box className={classes.container}>
        <Box className={classes.wrapper}>
          <Box className={classes.orgAndStatusContainer}>
            <Typography className={classes.organization}>{organizationName}</Typography>
            <Box
              className={classes.orgTypeContainer}
              sx={{
                backgroundColor: getRGBA(orgTypeColor, 0.1)
              }}
            >
              <Typography
                className={classes.orgType}
                sx={{ color: orgTypeColor }}
              >
                {orgTypeLabel}
              </Typography>
            </Box>
            {showESocialChip && (
              <Box className={eSocialStatus ? classes.eSocialContainerConnected : classes.eSocialContainerPending}>
                <Typography className={eSocialStatus ? classes.eSocialConnected : classes.eSocialPending}>
                  {eSocialStatus ? 'eSocial autenticado' : 'eSocial não autenticado'}
                </Typography>
              </Box>
            )}
          </Box>
          <Typography className={classes.federalTaxId}>{federalTaxId}</Typography>
        </Box>
        <ChevronRight />
      </Box>
    </ButtonBase>
  )
}

export default OrganizationOptions
